import * as React from 'react';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { mapListingTypesToListinsSearchCategories } from '@kamernet/core/Routing/routes/ListingsSearch';
import KNLogo from '@kamernet/icons/KN_Logo.svg';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { Breadcrumbs as MuiBreadcrumbs } from '@kamernet/components/Breadcrumbs';
import {
  RoomTypeIDPluralTranslations,
  RoomTypeIDTranslations,
} from '@kamernet/modules/Listing/translations';
import { ListingDetailsContext } from '@kamernet/views/ListingDetails/ListingDetailsContext';

import styles from './Breadcrumbs.module.css';

export const Breadcrumbs = () => {
  const { T, locale } = useIntl();
  const placeHolder = '...';
  const isDesktop = useMediaIsDesktop();
  const { listingDetails } = ListingDetailsContext.useContext();

  return (
    <section data-testid="breadcrumb-container">
      <MuiBreadcrumbs>
        <MuiBreadcrumbs.Link href={ROUTES.Home.getURL({}, locale)}>
          <KNLogo className={styles.icon} />
          {T('LBL_SMARTBANNER_TITLE')}
        </MuiBreadcrumbs.Link>
        {isDesktop && (
          <MuiBreadcrumbs.Link
            href={ROUTES.ListingsSearchCity.getURL(
              {
                city: listingDetails.citySlug,
                searchCategories: mapListingTypesToListinsSearchCategories([
                  listingDetails.listingTypeId,
                ]),
              },
              locale,
            )}
          >
            {locale === Locale.nl
              ? T(
                  '%_%',
                  T(RoomTypeIDPluralTranslations[listingDetails.listingTypeId]),
                  listingDetails.computedCityName,
                )
              : T(
                  '%_%',
                  listingDetails.computedCityName,
                  T(RoomTypeIDPluralTranslations[listingDetails.listingTypeId]),
                )}
          </MuiBreadcrumbs.Link>
        )}
        {isDesktop ? (
          <MuiBreadcrumbs.Link
            href={ROUTES.ListingsSearchStreet.getURL(
              {
                city: listingDetails.citySlug,
                street: listingDetails.streetSlug,
                searchCategories: mapListingTypesToListinsSearchCategories([
                  listingDetails.listingTypeId,
                ]),
              },
              locale,
            )}
          >
            {locale === Locale.nl
              ? T(
                  '%_%',
                  T(RoomTypeIDPluralTranslations[listingDetails.listingTypeId]),
                  listingDetails.computedStreetName,
                )
              : T(
                  '%_%',
                  listingDetails.computedStreetName,
                  T(RoomTypeIDPluralTranslations[listingDetails.listingTypeId]),
                )}
          </MuiBreadcrumbs.Link>
        ) : (
          <MuiBreadcrumbs.Text>{placeHolder}</MuiBreadcrumbs.Text>
        )}

        <MuiBreadcrumbs.Text isActive>
          {T(
            '%_%',
            T(RoomTypeIDTranslations[listingDetails.listingTypeId]),
            listingDetails.listingId,
          )}
        </MuiBreadcrumbs.Text>
      </MuiBreadcrumbs>
    </section>
  );
};
